import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import DefaultLayout from '../../components/DefaultLayout'
import SmoothList from 'react-smooth-list'
import { setAllProducts } from '../../redux/root-reducer'
import Item from './Item'
import styled from 'styled-components'
import { useParams } from 'react-router'
import { supabase } from '../../App'
import Loader from '../../components/Loader'
import Filters from "../../components/Filters/Filters"

const CatalogHeader = styled.div`
    background-color: #f0ebe6;
    color: #131313;
    padding: 50px 0;
    width: 100%;

    .container {
        display: flex;
        justify-content: space-between;
        text-align: left;
        align-items: flex-start;

        & > div {
            display: flex;
            flex-direction: column;
            width: 50%;
        }
    }

    p {
        margin-bottom: 22px;
        color: #131313;
    }

    @media screen and (max-width: 768px) {
        .container {
            flex-direction: column;
            & > div {
                width: 100% !important;
                text-align: center;
            }
        }
        p {
            margin-top: 25px;
            margin-bottom: 0 !important;
        }
    }
`

const Title = styled.h1`
    font-size: 48px;
    font-weight: 600;
    line-height: 1.15;
    letter-spacing: calc(-1 * calc(36px * 0.01));
    padding-right: 100px;
    @media screen and (max-width: 768px) {
        font-size: 36px !important;
        padding-right: 0 !important;
    }
`

const Subtitle = styled.h2`
    font-size: 21px;
    line-height: 1.4;
    margin-top: 1em;
    font-weight: 600;
    @media screen and (max-width: 768px) {
        font-size: 19px !important;
    }
`

const Grid = styled.div`
    .catalog {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 21.3px;
        justify-content: space-between;
    }

    .catalog-loader {
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
            font-size: 20px;
        }
    }

    @media screen and (max-width: 768px) {
        .catalog {
            /* grid-template-columns: repeat(1, 294px)!important; */
            grid-template-columns: repeat(1, 300px) !important;
            justify-content: center;
            grid-gap: 50px !important;
        }
    }
`

const Catalog = (props) => {
    const [list, setList] = useState([])
    const [isFetching, setIsFetching] = useState(true)

    const { id } = useParams()

    useEffect(() => {
        const loadProducts = async () => {
            if (id) {
                let { data } = await supabase
                    .from('products')
                    .select('id, cost, title, images, category')
                    .eq('category', id)

                if (data) {
                    props.setAllProducts(data)
                    setList(data)
                    setIsFetching(false)
                }
            } else {
                let { data } = await supabase
                    .from('products')
                    .select('id, cost, title, images, category')

                if (data) {
                    props.setAllProducts(data)
                    setList(data)
                    setIsFetching(false)
                }
            }
        }

        loadProducts()
    }, [id])

    return (
        <DefaultLayout>
            <CatalogHeader>
                <div className="container">
                    <div>
                        <Title>
                            Finely crafted wood interior accessories for Tesla.
                        </Title>
                        <Subtitle>German craftsmenship, real wood.</Subtitle>
                    </div>
                    <div>
                        <p>
                            A passion for functional design and an appreciation
                            for the minimalist Tesla aesthetic. We craft
                            interior wood covers for Tesla Model 3 and Model Y.
                            We hand select individual pieces from around the
                            world in five wood varieties, to offer an array of
                            colors, textures, and grains.
                        </p>
                    </div>
                </div>
            </CatalogHeader>

            <div
                className="container"
                style={{
                    margin: '0 auto 60px',
                }}
            >
                <Filters />
                <Grid>
                    {list.length ? (
                        <SmoothList className="catalog">
                            {list.map((product) => (
                                <Item key={product.id} i={product} />
                            ))}
                        </SmoothList>
                    ) : (
                        isFetching && (
                            <div className="catalog-loader">
                                <Loader />
                            </div>
                        )
                    )}
                    {list.length === 0 && !isFetching && (
                        <div className="catalog-loader">
                            <p>No products found in this category.</p>
                        </div>
                    )}
                </Grid>
            </div>
        </DefaultLayout>
    )
}

let mapStateToProps = (state) => {
    return {
        products: state.root.allProducts,
        searchString: state.root.searchString,
    }
}

export default connect(mapStateToProps, { setAllProducts })(Catalog)
